<template lang="pug">
section.av-banner.aa-banner(
  role="complementary"
  aria-labelledby="banner-heading"
)
  .icon.aa-logo(role="img" aria-label="AA logo")
  p#banner-heading Your AA delivery partner
</template>

<script lang="ts">
import { defineComponent } from "vue"
import "@anyvan-ui/banner/index.css"

export default defineComponent({
  name: "AABanner"
})
</script>
